// Guided-tour launcher on a screen's hero — prefix `thb-`. The control itself
// is the library SecondaryButton (DS glass pill), so this file only styles the
// wrapper that carries the one-time first-visit pulse ring (respects
// reduced-motion). Aggregated once in componentStyles.
export const tourHelpButtonStyles = `
  .thb-wrap {
    position: relative;
    display: inline-flex;
    border-radius: var(--rad-catchup-button);
  }
  /* one-time nudge on first visit to a screen */
  .thb-wrap--pulse::after {
    content: "";
    position: absolute;
    inset: -3px;
    border-radius: inherit;
    border: 2px solid rgba(255, 255, 255, 0.85);
    opacity: 0;
    pointer-events: none;
    animation: thb-pulse 1.6s var(--ease-standard) 3;
  }
  @keyframes thb-pulse {
    0% { transform: scale(0.97); opacity: 0.6; }
    70% { transform: scale(1.12); opacity: 0; }
    100% { transform: scale(1.12); opacity: 0; }
  }
  @media (prefers-reduced-motion: reduce) {
    .thb-wrap--pulse::after { animation: none; }
  }
`;
